import React from "react"

import { TeamMember } from "entities/team-members/types/TeamMember"

import { TeamMemberChipView } from "./TeamMemberChipView"
import { useTeamMemberChip } from "./model/useTeamMemberChip"

export interface TeamMemberChipProps {
  teamMember: TeamMember
}

export const TeamMemberChip = React.memo((props: TeamMemberChipProps) => {
  return <TeamMemberChipView {...useTeamMemberChip(props)} />
})
